// Mirrors the `alerts` schema + operations.incidents. Keep in sync with the
// RealityDatabase migrations (20260710085022_alerts_schema.sql).

export type TriageStatus =
  | 'new' | 'acknowledged' | 'investigating' | 'assigned' | 'resolved' | 'wont_fix';

export type Severity = 'info' | 'warning' | 'error';

export interface Developer {
  id: string;
  email: string;
  display_name: string;
  is_active: boolean;
  receives_floor: boolean;
  is_admin: boolean;
  created_at: string;
  updated_at: string;
}

export interface IncidentTriage {
  incident_id: string;
  status: TriageStatus;
  is_floor: boolean;
  severity: Severity | null;
  incident_type: string | null;
  category: string | null;
  source: string | null;
  room_id: string | null;
  pc_instance_id: string | null;
  occurred_at: string | null;
  message: string | null;
  claimed_by: string | null;
  assigned_to: string | null;
  acknowledged_at: string | null;
  resolved_at: string | null;
  resolved_by: string | null;
  note: string | null;
  first_notified_at: string | null;
  last_nagged_at: string | null;
  nag_count: number;
  escalated_all: boolean;
  created_at: string;
  updated_at: string;
}

export interface AlertSubscription {
  id: string;
  developer_id: string;
  label: string | null;
  is_active: boolean;
  match_types: string[] | null;
  match_categories: string[] | null;
  match_sources: string[] | null;
  min_severity: Severity | null;
  match_room_ids: string[] | null;
  match_pc_ids: string[] | null;
  needs_dev_only: boolean;
  created_at: string;
  updated_at: string;
}

export interface DeveloperAvailability {
  developer_id: string;
  is_ooo: boolean;
  ooo_since: string | null;
  ooo_until: string | null;
  delegate_developer_id: string | null;
  note: string | null;
  updated_at: string;
}

export interface NotificationTarget {
  id: string;
  developer_id: string;
  kind: 'pushover' | 'ntfy' | 'web_push' | 'discord';
  label: string | null;
  config: Record<string, unknown>;
  enabled: boolean;
  priority: number;
  verified: boolean;
  last_used_at: string | null;
  last_error: string | null;
  created_at: string;
}

// operations.incidents (the source feed; append-only, read-only from here)
export interface Incident {
  id: string;
  created_at: string;
  occurred_at: string;
  type: string;
  severity: Severity | null;
  source: string | null;
  message: string | null;
  pc_instance_id: string | null;
  room_id: string | null;
  experience_id: string | null;
  run_id: string | null;
  metadata: Record<string, any>;
  log_storage_path: string | null;
  log_url: string | null;
}

export const INCIDENT_TYPES = ['manual', 'freeze', 'crash', 'diagnostic'] as const;
export const SEVERITIES: Severity[] = ['info', 'warning', 'error'];
export const OPEN_STATUSES: TriageStatus[] = ['new', 'acknowledged', 'investigating', 'assigned'];
